import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Project {
  title: string;
  image: string;
}
const projects: Project[] = [{
  title: 'White kitchen with honed marble countertops and full stone backsplash',
  image: 'https://cdn.magicpatterns.com/uploads/5HVyBUv7qSRrdP1hgEV6iD/gallery-kitchen-31.png'
}, {
  title: 'Granite island with patterned tile backsplash and pendant lighting',
  image: 'https://cdn.magicpatterns.com/uploads/dXEaR7Ft2jexB8hbrm4DyW/gallery-kitchen-03-1024x682.png'
}, {
  title: 'Speckled granite island with undermount sink',
  image: 'https://cdn.magicpatterns.com/uploads/1DLxJngQQmirAd2pQHtezk/gallery-kitchen-11-1024x682.png'
}, {
  title: 'Blue and gold quartzite island in a bright white kitchen',
  image: 'https://cdn.magicpatterns.com/uploads/b81KikYT1Zt1GpVJWvX4fL/gallery-kitchen-20-1024x682.png'
}, {
  title: 'Raised bar top with decorative corbels and chiseled stone edge',
  image: 'https://cdn.magicpatterns.com/uploads/2oxXidguStpTErSyCr2SvE/gallery-kitchen-26.png'
}, {
  title: 'Marble perimeter counters with farmhouse sink and range wall',
  image: 'https://cdn.magicpatterns.com/uploads/2MvsDz37D16Q9Ezkh4KhQW/gallery-kitchen-28.png'
}, {
  title: 'Polished granite island with undermount sink and bar seating',
  image: 'https://cdn.magicpatterns.com/uploads/6egiFjck6c3TbqSh1u2yfU/gallery-kitchen-05-1024x682.png'
}, {
  title: 'Open kitchen with quartzite island and grey subway backsplash',
  image: 'https://cdn.magicpatterns.com/uploads/q9BaoGz9c1H2sZVgP2sSDc/gallery-kitchen-21-1024x682.png'
}, {
  title: 'Grey shaker kitchen with white quartz island and farmhouse sink',
  image: 'https://cdn.magicpatterns.com/uploads/udSPjVHd4RvwszxH3MRdeH/gallery-kitchen-33-1024x682.png'
}, {
  title: 'Timber-frame kitchen with marble island in a wood-clad great room',
  image: 'https://cdn.magicpatterns.com/uploads/frrToGFAs1Lqn7WiFxAJo6/gallery-kitchen-24.png'
}];
export function ProjectsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  function scrollByAmount(direction: 1 | -1) {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction * (el.clientWidth * 0.8),
      behavior: 'smooth'
    });
  }
  return <section className="w-full bg-brand-cream" data-id="element-58" data-mp="1ygh3l7opbo9a">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-59" data-mp="1apl6pw5e22v6">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end" data-id="element-60" data-mp="15r063vm85h67">
          <div className="max-w-2xl" data-id="element-61" data-mp="1jqrqce3c3tsn">
            <h2 className="font-display text-3xl text-brand-charcoal sm:text-4xl" data-id="element-62" data-mp="1jrucy9tmja2r">
              Residential &amp; Commercial Countertop Projects
            </h2>
            <p className="mt-5 text-base leading-relaxed text-gray-600" data-id="element-63" data-mp="2v5og5q7cen12">
              To help you plan your dream kitchen or bath, take a look at some of our favorite
              projects. Our craftsmanship, attention to detail, and creativity can help you bring
              your idea to life.
            </p>
          </div>

          <div className="flex shrink-0 gap-2" data-id="element-64" data-mp="32qik3925y4nz">
            <button type="button" onClick={() => scrollByAmount(-1)} aria-label="Scroll projects left" className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white text-brand-charcoal transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-65" data-mp="32n4i41xevxh2">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="3mc55hlon3z6b" />
            </button>
            <button type="button" onClick={() => scrollByAmount(1)} aria-label="Scroll projects right" className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white text-brand-charcoal transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-67" data-mp="37nisvrqedlis">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="2gi50lttqco88" />
            </button>
          </div>
        </div>

        <div ref={scrollRef} className="no-scrollbar mt-10 flex gap-5 overflow-x-auto scroll-smooth pb-2" data-id="element-69" data-mp="2cg09p2uo25pa">
          {projects.map(project => <div key={project.title} className="w-72 shrink-0 snap-start overflow-hidden rounded-xl sm:w-96" data-id="element-70" data-mp="22ic3ngrm1brt">
              <img src={project.image} alt={project.title} className="h-56 w-full rounded-xl object-cover sm:h-64" data-id="element-71" data-mp="304t06jsirlci" />
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-72" data-mp="2qegdakx8fg37">
          <a href="#get-started" className="inline-flex items-center justify-center rounded-md bg-brand-teal px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-tealDark" data-id="element-73" data-mp="2lhq32e83zepp">
            Schedule Your Free Consultation
          </a>
        </div>
      </div>
    </section>;
}